import actionTypes from 'Redux/constants';

export const setCurrentRecord = payload => dispatch => {
  dispatch({
    type: actionTypes.history.setCurrentRecord,
    payload,
  });
};

export const setReviewHistory = payload => dispatch => {
  dispatch({
    type: actionTypes.history.setReviewHistory,
    payload,
  });
};
